<div fxFlex="row" fxLayoutAlign="space-between center">
  <div class="breadcrumb">
    <a routerLink="/">Home</a>
    {{ breadcrumb }}
  </div>
  <app-header [profile]="profileInfo" [pic]="profilePic"></app-header>
</div>

